import 'intl';
import React from 'react';
import { initializeModal } from '@myjobglasses/dsm';
import {
  utils,
  Button,
  Row,
  Jumbotron,
  Carousel,
} from 'react-bootstrap';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import 'react-dates/initialize';
import 'moment/locale/fr';
import 'moment/locale/en-in';
import Router from './Router';
const { bootstrapUtils } = utils;

Modal.setAppElement('#react-modal');
initializeModal('#react-modal');

bootstrapUtils.addStyle(Button, 'default-blue');
bootstrapUtils.addStyle(Button, 'remove');
bootstrapUtils.addStyle(Button, 'cancel');
bootstrapUtils.addStyle(Button, 'filters');
bootstrapUtils.addStyle(Button, 'tag');
bootstrapUtils.addStyle(Button, 'dismiss');
bootstrapUtils.addStyle(Button, 'cta-block');
bootstrapUtils.addStyle(Button, 'vip');
bootstrapUtils.addStyle(Row, 'cover');
bootstrapUtils.addStyle(Jumbotron, 'cover-content');
bootstrapUtils.addStyle(Row, 'press-article');
bootstrapUtils.addStyle(Row, 'cover-overlay');
bootstrapUtils.addStyle(Row, 'background-video');
bootstrapUtils.addStyle(Row, 'scroll-down');
bootstrapUtils.addStyle(Carousel, 'plans');

window.Rollbar?.configure({
  payload: {
    current_aphrodite_version: process.env.CURRENT_APHRODITE_VERSION,
  },
});

ReactDOM.render(<Router />, document.getElementById('root'));
